import {useEffect, useState} from 'react';

export function useFontPaintReady(
  fontFamily: string,
  fontSize: string = '32px'
) {
  const [paintReady, setPaintReady] = useState(false);

  useEffect(() => {
    const span = document.createElement('span');
    span.innerText = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    span.style.position = 'absolute';
    span.style.visibility = 'hidden';
    span.style.fontSize = fontSize;
    span.style.fontFamily = 'serif';
    document.body.appendChild(span);

    const initialWidth = span.offsetWidth;
    span.style.fontFamily = `${fontFamily}, serif`;

    let frame: number;
    function check() {
      if (span.offsetWidth !== initialWidth) {
        setPaintReady(true);
        span.remove();
      } else {
        frame = requestAnimationFrame(check);
      }
    }
    check();

    return () => {
      span.remove();
      if (frame) {
        cancelAnimationFrame(frame);
      }
    };
  }, [fontFamily, fontSize]);

  return {paintReady};
}
